"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Everything to do with discounts and coupons.
 */
var service_1 = require("../service");
var Discounts;
(function (Discounts) {
    // Search for available discounts by name
    //
    function searchByQuery(requestBody) {
        var service = new service_1.EVAService("SearchDiscountsByQuery");
        return new Promise(function (resolve, reject) {
            // Perform the call and capture the resulting promise
            //
            service.call().then(function (serviceResult) {
                resolve(serviceResult.response);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    }
    Discounts.searchByQuery = searchByQuery;
    // List all manual discounts
    //
    function listManualDiscounts(requestBody) {
        var service = new service_1.EVAService("ListManualDiscounts");
        return new Promise(function (resolve, reject) {
            // Perform the call and capture the resulting promise
            //
            service.call().then(function (serviceResult) {
                resolve(serviceResult.response);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    }
    Discounts.listManualDiscounts = listManualDiscounts;
    // Get coupon details
    //
    function getDiscountCoupons(requestBody) {
        var service = new service_1.EVAService("GetDiscountCoupons");
        return new Promise(function (resolve, reject) {
            // Perform the call and capture the resulting promise
            //
            service.call().then(function (serviceResult) {
                resolve(serviceResult.response);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    }
    Discounts.getDiscountCoupons = getDiscountCoupons;
})(Discounts = exports.Discounts || (exports.Discounts = {}));
